export const ModuleConst = {
  Dashboard: 1,
  Inventory: 2,
  list: 2.1,
  request: 2.2,
  reassign: 2.3,
  OrderManagement: 3,
  Orders: 3.1,
  Returns: 3.2,
  ManagePayout: 4,
  ManageDriverWallet: 5,
  ReportManagement: 6,
  RackManagement: 7,
  SubAdmin: 8,
  Settings: 9
};
